const getEnviromentConfig = (config) => {
  switch (config) {
    case EnviromentTypeEnum.Local:
      return {
        baseUrl: "https://localhost:7094/",
        serviceUrl: "https://localhost:7094/api/Service",
        imgBaseurl: "https://localhost:7094/img/upload/",
      };
    case EnviromentTypeEnum.QA:
      return {
        baseUrl: "http://qa_playpro.nascentinnovations.com/",
        serviceUrl: "http://qa_playpro.nascentinnovations.com/api/Service",
        imgBaseurl: "http://qa_playpro.nascentinnovations.com/img/upload/",
      };
    case EnviromentTypeEnum.Dev:
      return {
        baseUrl: "https://dev3playpro.nascentinnovations.com/",
        serviceUrl: "https://dev3playpro.nascentinnovations.com/api/Service",
        imgBaseurl: "https://dev3playpro.nascentinnovations.com/img/upload/",
      };
    case EnviromentTypeEnum.Production:
      return {
        baseUrl: "http://pointofsale.nascentinnovations.com/",
        serviceUrl: "http://pointofsale.nascentinnovations.com/api/Service",
        imgBaseurl: "http://pointofsale.nascentinnovations.com/img/upload/",
      };
    case EnviromentTypeEnum.Demo:
      return {
        baseUrl: "https://playprodemo.nascentinnovations.com/",
        serviceUrl: "https://playprodemo.nascentinnovations.com/api/Service",
        imgBaseurl: "https://playprodemo.nascentinnovations.com/img/upload/",
      };
  }
};

export const ToCSharpFormat = "YYYY-MM-DDTHH:mm:ss";
export const ViewDateFormat = "DD MMM yyyy";
export const ViewDateTimeFormat = "DD MMM yyyy, hh:mm A";
export const DateTimeFormat = "DD MMM YYYY, hh:mm A";
export const TimeFormat = "HH:mm";
export const ViewTimeOnly = "hh:mm A";
export const DateTimeminFormat = "YYYY-MM-DDTHH:mm";
export const DateminFormat = "YYYY-MM-DD";
export const AddHours = 5;
export const DateTime = "YYYY-MM-DD HH:mm";
export const DateTimeSec = "YYYY-MM-DD HH:mm:ss";
export const FloatMin = 1.175494351e-38;
export const FloatMax = 3.402823466e38; // 32-bit floating point
export const DoubleMin = 0.0; // range - 2.2250738585072014e-308;
export const DoubleMax = 200.0; // range -  1.7976931348623157e308; //64-bit double-precision floating point
export const DoubleMaximum = 1.7976931348623157e308;
export const IntMin = 0;
export const IntMax = 99999999;
export const IntCourtPriceMin = 100;
export const IntMinLevel = 1;
export const IntSportMaxLevel = 50;
export const IntMinPlatFormFees = 10;
export const IntMaxPlatFormFees = 100000;
export const IntMaxnoofplayers = 20;
export const UnAuthorizedMessageForKey =
  "You're not authorized to perform this action as you provide wrong key!";
export const duration = [
  { id: 30, name: "30 min" },
  { id: 60, name: "1 hr" },
  { id: 90, name: "1 hr 30 min" },
  { id: 120, name: "2 hr" },
  { id: 150, name: "2 hr 30 min" },
  { id: 180, name: "3 hr" },
];

const EnviromentTypeEnum = Object.freeze({
  Local: 1,
  QA: 2,
  Dev: 3,
  Production: 4,
  Demo: 5,
});

// Get environment from runtime config if available, otherwise use process.env
const envType = parseInt(window.RUNTIME_CONFIG.ENVIRONMENT, 10);

export const envIsLive =
  envType == EnviromentTypeEnum.Demo || envType == EnviromentTypeEnum.Live;

// Set fallback for user management
export const isUserManagementEnabled = true;

export const ResultStatus = Object.freeze({
  Unauthorized: 0,
  Success: 1,
  Error: 2,
  NotFound: 3,
  Warning: 4,
  InProcess: 5,
});

export const SignUpTypeEnum = Object.freeze({
  EmailorPhone: 1,
  Google: 2,
  Apple: 3,
  // Facebook: 3
});

export const GenderTypeEnum = Object.freeze({
  Male: 1,
  Female: 2,
  Other: 3,
});

export const UserTypeEnum = Object.freeze({
  Super_Admin: 1,
  Club_Specific: 2,
  Others: 3,
});

export const RoleEnum = Object.freeze({
  Super_Admin: 1,
  Club_Manager: 2,
  Club_Sub_User: 3,
  Player: 4,
  Tournament_Manager: 6,
});

export const SportFeatureTypeEnum = Object.freeze({
  Type: 1,
  Feature: 2,
  No_of_Players: 3,
});

export const PaymentTypeEnum = Object.freeze({
  Cash: 1,
  Online: 2,
  Payment_GateWay: 3,
  Pay_On_Club: 4,
  Online_Partial_Pay: 5,
});

export const MatchTypeEnum = Object.freeze({
  Friendly: 1,
  Competitive: 2,
});

export const OpenMatchTypeEnum = Object.freeze({
  Open: 1,
  Exclusive: 2,
});

export const OpenMatchStatusEnum = Object.freeze({
  Pending: 1,
  Completed: 2,
  Cancelled: 3,
});

export const ClubDisplayTypeEnum = Object.freeze({
  Court_First: 1,
  Slot_First: 2,
  Duration_First: 3,
});

export const BookingPaymentMethodEnum = Object.freeze({
  Creator_Pays_All: 1,
  Each_Pays_Own: 2,
});

// export const BookingModeEnum = Object.freeze({
//   App_Booking: 1,
//   Club_Booking: 2,
// });

export const BookingModeEnum = Object.freeze({
  App_Booking: 1,
  Club_Booking: 2,
  My_App_Booking: 3,
  Web_Booking: 4,
  Whatsapp_Booking: 5,
});

export const BookingStatusEnum = Object.freeze({
  Pending: 1,
  Waiting_For_Confirmation: 2,
  Booked: 3,
  Cancelled: 4,
  Cancelled_By_Club: 5,
  Cancelled_Due_To_Lack_Of_Player: 6,
});

export const MatchResultTypeEnum = Object.freeze({
  Win: 1,
  Lose: 2,
  Draw: 3,
  Reward: 4,
});

export const PaymentStatusEnum = Object.freeze({
  Paid: 1,
  Partial_Paid: 2,
  Un_Paid: 3,
});

export const BookingTypeEnum = Object.freeze({
  Public: 1,
  Private: 2,
});

export const NotificationTypeEnum = Object.freeze({
  PrivateBooking: 1,
  PublicBooking: 2,
  Booking_Confirm: 3,
  InviteFriendToPublicBooking: 4,
  BookingResultUpload: 5,
  PublicPlayerJoinedMatch: 6,
  Confirmed_Booking: 7,
  Booking_Reschedule: 8,
  Promotional_Message: 9,
  Club_Notification: 10,
});

export const PlayerPointsLogTypeEnum = Object.freeze({
  Inital_Level: 1,
  Booking: 2,
  League_Reward: 3,
});

export const LeaderBoardFilterTypeEnum = Object.freeze({
  Global: 1,
  Club: 2,
  Country: 3,
  State: 4,
  City: 5,
});

export const PadelPreferenceShotType = Object.freeze({
  Forehand: 1,
  Backhand: 2,
  Volley: 3,
  Overhead: 4,
  Smash: 5,
  Slice: 6,
  Lob: 7,
  Drive: 8,
  Block: 9,
});

export const respEnum = Object.freeze({
  Unauthorized: 0,
  Success: 1,
  Error: 2,
  NotFound: 3,
  Warning: 4,
  InProcess: 5,
});

export const TransactionLogTypeEnum = Object.freeze({
  Court_Booking: 1,
  Public_Match_Joining: 2,
  Tournament_Joining: 3,
  Payment_Received: 4,
  PromoCode_Redeemed: 5,
  Club_Discount: 6,
  Payment_Refund: 7,
  Bank_Discount: 8,
});

export const TransactionLogStatusEnum = Object.freeze({
  Initiate: 1,
  Success: 2,
  Failed: 3,
  Refundable: 4,
  Refunded: 5,
});

export const ExternalSyncingLogTypeEnum = Object.freeze({
  Generate_Token: 1,
  Post_Data: 2,
});

export const DayOfWeekEnum = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const TournamentVenueTypeEnum = Object.freeze({
  // Country_Wise : 1,
  //     State_Wise : 2,
  City_Wise: 3,
  Club_Wise: 4,
});

export const HolidayTypeEnum = Object.freeze({
  Club: 1,
  Court: 2,
  Club_Recurring: 3,
});

//old name TournamentTypeEnum

export const TournamentMatchStageEnum = Object.freeze({
  Group_Match: 1,
  Quarter_Final: 2,
  Semi_Final: 3,
  Final: 4,
  Knockout: 5,
  Third_Position: 6,
  Round_of_16: 7,
});

export const SlotStatusEnum = Object.freeze({
  Available: 1,
  Booked: 2,
  Club_Holiday: 3,
  Court_Holiday: 4,
  Club_Holiday_Recurring: 5,
});

export const TournamentMatchResultEnum = Object.freeze({
  Not_Uploaded: 0,
  Team_A_Won: 1,
  Team_B_Won: 2,
  Tied: 3,
  No_Result: 4,
});

export const PushNotificationTypeEnum = Object.freeze({
  Promotion: 1,
  Alert: 2,
  Reminder: 3,
  Club_Notification: 4,
});

export const PromoCodeDiscountTypeEnum = Object.freeze({
  Percentage: 1,
  Fixed_Amount: 2,
});

export const ClubPaymentLogTypeEnum = Object.freeze({
  Payment_Received: 1,
  Payment_Refund: 2,
});

export const ClubPaymentLogTransactionNatureEnum = Object.freeze({
  Customer_Payment: 1,
});

export const SearchTypeEnum = Object.freeze({
  Server_Search: 1,
  Local_Search: 2,
});

export const CustomTimeoutUrlEnum = Object.freeze({
  SendPushNotificationToUsers: "SendPushNotificationToUsers",
});

export const ImageFolderEnum = Object.freeze({
  upload: 1,
  profiles: 2,
  transactions: 3,
  trmt_logo: 4,
  contactus: 5,
  products: 6,
});

export const ContactusStatusEnum = Object.freeze({
  New: 1,
  Open: 2,
  Closed: 3,
});

export const BookingMasterTypeEnum = Object.freeze({
  Recurring_Days: 1,
  Specific_Dates: 2,
});

export const ClubConfigTypeEnum = Object.freeze({
  WhatsApp_Message_To_Owners: 1,
});

export const ClubBankDiscountTypeEnum = Object.freeze({
  Percentage: 1,
  Fixed_Amount: 2,
});

export const ClubPrivacyTypeEnum = Object.freeze({
  Public: 0,
  Private: 1,
});

export const SliderTypeEnum = Object.freeze({
  Club_Promotion: 1,
  Tournament: 2,
  Promotion: 3,
  Federation: 4,
  Summer_Camp: 5,
  Summer_Camp_Detail: 6,
});

export const AmenityTypeEnum = Object.freeze({
  Session_Based: 1,
  Package_Based: 2,
});

export const TermsnConditionTypeEnum = Object.freeze({
  Public_Match: 1,
  Private_Match: 2,
  Pay_On_Club_Payment: 3,
  Bank_Transfer: 4,
});

export const StockLogTypeEnum = Object.freeze({
  Stock_In: 1,
  Stock_Out: 2,
});

export const SaleOrderStatusEnum = Object.freeze({
  // Hold: 1,
  Confirmed: 2,
  Cancelled: 3,
});

export const SaleOrderTypeEnum = Object.freeze({
  POS: 1,
  PlayPro: 2,
  MyApp: 3,
  MyWeb: 4,
});

export const TransactionSourceEnum = Object.freeze({
  Booking: 0,
  Amenity_Booking: 1,
  POS: 2,
});

export const RequestTypeEnum = Object.freeze({
  Application_User: 1,
  Player: 2,
});

export const TournamentRuleMatchFormatTypeEnum = Object.freeze({
  RaceToSix: 1,
  TwoSetsSuperTieBreak: 2,
  ThreeSets: 3,
});

export const TournamentJoinType = Object.freeze({
  Admin_Only: 1,
  App_and_Admin: 2,
  App_Only: 3,
});

export const TournamentMatchPlayStatusEnum = Object.freeze({
  Pending: 0,
  In_Progress: 1,
  Completed: 2,
});

export const ClubConfigLogTypeEnum = Object.freeze({
  WhatsApp_Message_To_Owners: 1,
  WhatsApp_OTP_On_Signup: 2,
  Customer_New_Booking_Notification: 3,
});

export const BookingSummaryTypeEnum = Object.freeze({
  Welcome_Block: 1,
  Users_Booking_Summary: 2,
  Booking_Summary: 3,
  Reports_Area: 4,
  Total_Income_Summary: 5,
  Top_Customers: 6,
  //Grouped_Stack_Bar: 7,
  //Line_Column: 8,
  Paid_Unpaid: 9,
  Sport_Court_Revenue: 10,
});

export const AppUserSettingsTypeEnum = Object.freeze({
  Add_Booking: 1,
  Add_Discount: 2,
  Cancel_Booking: 3,
  POS_Cancel_Order: 4,
  POS_Order_Date_Selection: 5,
  Reschedule_Booking: 6,
});

export const BookingCancellationReasonTypeEnum = Object.freeze({
  Booking: 1,
});

export const AttachmentHistoryLogTypeEnum = Object.freeze({
  Booking_Payment: 1,
  Booking_Discount: 2,
  Pos_Payment: 3,
});

export const SliderDisplayTypeEnum = Object.freeze({
  Dashboard: 1,
  Bank_Discounts: 2,
  Tournaments: 3,
  Promocodes: 4,
});

export const AmericanoTypeEnum = Object.freeze({
  Americano: 1,
  Maxicano: 2,
});

export const AmericanoAccessTypeEnum = Object.freeze({
  NoAccess: 1,
  FullAccess: 2,
});

export const AmericanoMatchResultTypeEnum = Object.freeze({
  Win: 1,
  Loss: 2,
  Tie: 3,
  NoResult: 4,
});

export const AmericanoMatchResultEnum = Object.freeze({
  Not_Uploaded: 0,
  Side_A_Won: 1,
  Side_B_Won: 2,
  Tied: 3,
  No_Result: 4,
});

export const TaxTypeEnum = Object.freeze({
  Inclusive: 1,
  Exclusive: 2,
});
const AppConstant = getEnviromentConfig(envType);

export default AppConstant;
